// mq服务js
// 外呼和在线客服mq处理连接都在这

import eventBus from "../../util/eventBus";

export const MqService= {
  data(){
    return{
      mqClient: null,
      agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
      topic: '',
      subscribeId: null,
      reconnectionCount: 0,
    }
  },
  methods:{
      //MQ建立连接
    connect: function () {
      this.mqClient = this.$store.getters.getMqClient();
      if (!this.mqClient || !this.mqClient.connected) {
          this.mqClient = this.Stomp.client(this.MQTT_SERVICE);
      }

      this.$store.commit('putMqClient',this.mqClient);

      const headers = {
          login: this.MQTT_USERNAME,
          passcode: this.MQTT_PASSWORD
      };
      // SockJS does not support heart-beat: disable heart-beats
      this.mqClient.heartbeat.outgoing = 30000;
      this.mqClient.heartbeat.incoming = 30000;

      this.mqClient.connect(headers, this.onConnected, this.onFailed);

    },
    //消息订阅失败
    onFailed: function (frame) {
      this.isConnectMq = false;
      console.log("连接失败: " + frame);
      if(!this.mqClient.connected){
        this.mqClient = this.Stomp.client(this.MQTT_SERVICE); //连接mq
    }

    if(!this.reconnectionCount){ //如果没有重连，30s后进行重连，重连时判断client是否连接上，没连接上再次重连
        let that = this;
        setTimeout(function(){ //30s后再次重连
            that.reconnectMq();
        }, 10000);

    }
    },
    //订阅频道
    onConnected: function (frame) {
      let that = this;
      setTimeout(function () {
          console.log("mq订阅: " + frame);
          if (!that.mqClient.connected) {
              that.connect();
              return false;
          }
          that.topic = "/queue/" + that.agentInfo.companyCode + "_" + that.agentInfo.agentNumber;
          let param = {'auto-delete':true,'x-message-ttl':30000};
          // if(that.agentInfo.isSupportChat == '0'){  //不支持在线客服
          //   param = {'auto-delete':true,'x-message-ttl':30000};
          // }
          let object = that.mqClient.subscribe(that.topic, that.responseCallback,param);
          that.subscribeId = object.id;

          that.init();
          // that.initNotice();
        setTimeout(function(){ //1s后开始判断是否签入
          that.isAutoSignIn();
        }, 1000);
      }, 1000);
    },
    //接收消息处理
      responseCallback: function (frame) {
          if(frame.body == "isSqueezeLogin"){
            this.shutDownAll();
            return;
          }
          let body = JSON.parse(frame.body);
          if(body.type == "pushNoticerMessage"){  //公告类型
            if((","+body.msgSource+",").indexOf(','+this.agentInfo.employeeId+',') > -1){ 
              this.announcementReminder(body);
              this.$store.commit('pushNotice',body);
            }
          }else if(body.type == "pushNoticeWorkOrderMessage"){  //工单类型
            if((","+body.msgSource+",").indexOf(','+this.agentInfo.employeeId+',') > -1 && this.agentInfo.employeeId != body.agentNumber){ //包含本员工且不是本员工回复的
              this.$store.commit('pushGlobalNoticeMsgList',body);
              this.notice(body);
            }
            // this.$store.getters.getWorkOrderData();
          }else if(body.type == "pushRefreshWorkOrderMessage"){
            if(body.msgMarket && '刷新' == body.content && body.agentNumber != this.agentInfo.employeeId){
              eventBus.$emit('findWorkOrderIsOpen', body.msgMarket);
            }
          }else if ("pushDeleteWorkOrderMessage" == body.type){
            if(body.msgMarket && body.agentNumber != this.agentInfo.employeeId){
              eventBus.$emit('workOrderIsDelete', body.msgMarket);
            }
          }else if(body.type == "pushRefreshChatReplyMessage"){  //快捷词更新处理
            if(body.sessionChannel == '0' || body.msgSource == this.agentInfo.agentNumber){
              this.chatReplyWorkAndContent();
            }
          }else if('pushRefreshCustomerChatMessage' == body.type){
            //同步更新客户数据
            if(body.agentNumber != this.agentInfo.agentNumber){
              //不一样，说明不是自己操作的。执行更新
              eventBus.$emit('updateCustomFromOtherAgent',body.openId,body.sessionId);
            }
          }else if(body.type != "pushPointChatMessage" && body.type != "pushPublicChatMessage"
          && body.type != "pushDeleteChatMessage" && body.type != "pushConfChatMessage"){  //不是在线客服，才会进入处理
              this.onEvent(frame);
          }else{  //在线客服消息的处理
              if(body.type == "pushPointChatMessage"){  //是在线客服，才进行处理
                  if(body.agentNumber != this.agentInfo.agentNumber){  //不一样，说明不是自己的会话，显示
                    this.$store.commit('pushMsg',body);
                    this.$store.commit('pushGlobalNoticeMsgList',body);
                  }
                }else if(body.type == "pushPublicChatMessage"){   //公共消息处理，如排队中的客户，浏览中的客户，需要所有员工都收到的
                  this.$store.commit('pushMsg',body);
                }else if(body.type == "pushDeleteChatMessage"){ //删除所有座席都能看到的客户，比如排队中的客户
                  body.msgSource = body.msgSource+",";
                  if(body.msgSource.indexOf(this.agentInfo.agentNumber+",") == -1){  //如果不是当前座席，删除排队中的客户，是当前座席，则不删除
                    if(body.tip.indexOf("访客：") != -1 && '2' == body.sessionStatus && ('1' == body.sessionType || '3' == body.sessionType)){
                      let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(body.openId);
                      if(onlineInfo){
                        this.$store.commit('pushMsg',body);
                      }
                      return;
                    }
                    this.$store.commit('delOnlineData',body.openId);
                    window.midChangeCallbackFun(""); //删除时改变中间和右侧数据
                  }else{
                    this.$store.commit('pushMsg',body);
                  }
                }else if(body.type == "pushConfChatMessage"){ //多方会话收到的消息
                  if(body.sessionStatus == "2"){  //会话已结束,删除该会话数据
                    this.$store.commit('delOnlineData',body.openId);
                    window.midChangeCallbackFun("");
                  }else{
                    if(body.agentNumber != this.agentInfo.agentNumber){  //不一样，说明不是自己的会话，显示
                      this.$store.commit('pushMsg',body);
                      this.$store.commit('pushGlobalNoticeMsgList',body);
                    }
                  }
              }
          }
      },
      
      //公告提醒
      announcementReminder:function(body){
        this.$notify({
          title: '公告提醒',
          dangerouslyUseHTMLString: true,
          message: `<div style="width:280px">
                      <ul style="list-style: none;display: block;">
                        <li style="padding: 8px 0; border-top: 1px solid #e4e7ed; padding-left: 10px; padding-right: 10px;">
                          <div style="display: flex;align-items: center; height: 30px;">
                              <div style="margin-right: 16px; margin-top: 10px;"><img title="公告" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA1BJREFUWEfNV1tIVFEUXWfGxDFfc6+aLwzTUSmQJCLD+vAjf4QMgsQeBBHhjJX1kSCF9FFB9pFIc8fKhOghBoEGfhX0oUaRZgg9nOsDJKdQZ0x7aNnMiXvH0ZnrjOdWo3a+hrl7r7XOPvvsvQ+BysVfE4uplhTA5doCgnSAxAPQzrk7AToKigFoNN3ESZ/ajxta1UCTpYyihV69BrozBPQYQHg1gAs21E5BbrgwfWXSlDMRyDegAE4QjwKoAaD/M+JF1hJ5pcNkaPCH41cAbxHNlML0j8Q+7oRAsBsN5UrMRQI4s/U+CCllkZdkReJAdpRsdu/9FJr7vrBcAEqbHOWZ+70NfQSo3Xleog5te5LR1DclY5VmRaGoZQTPP04zRRACi91omI/uvIC5M7/JRADweG8KHDMulLTZZPPmoiRwYRrsevhBjTsoqHHClFkvGcsCpGzXQjegJuHKcmJwMT8WOx8M4639p0y4kQ9F+75UnO0cR33vZ7YISr9psSZjrDztkyxAL4iXCFDF8ozTafHmcBouvLCjrsf3Zp3M1ePcNh6bbg9hbNrJgpK+1zpMhtOyAE6wjivvuXSupdmRaoCYNq/HfqD62bjSbiZMO8kTucJp0OL99cTmGJzfHotOGzupmOwA8pN06B6dQaEiRyhwiHCW/lpQWuEN9Kg4GR22adS8dKjBZ9oUp0egsTABu1tHfDdF0Ug4s7UdhOxYTgFSBKRNKQUQoIdwgtUGkMTVEABggnCC+Murq8k6/B2BFMYsLpQZbo/B3XdTsH2VoN054C8Cch3gBJEqUf0JqCuIny+9alR4hzsoAtSQBrL57wVId82n5wf7Gi4RgQnCC+IrCuSyboHdmOE3wlKxks57qbX0NTSLt0BwhCUgIyYU68I9I6AvHatiBoyAVIj0gniQAHdYApYjCeVSnHS9K3zGGW0HEOYhWaEccDcjdzcUrwI4tcICFtpxnHkowYnZfhCyVhJRkatHdR6Py11BakYbIpASGYL1DYPuPSoHEuk/vWAtIyAW6XdqZAgqt3LyrBeM9WT4O6o6xjA4OevmV45kHhLeIgqUwhgM0kAYAYdSj4PasfyvRLLGcq9IrN7DZD4Sq/k084hY1cep8oyX63n+G5Eizcp/o4yQAAAAAElFTkSuQmCC"/></div> 
                                <div style="width: 85%; overflow: hidden;">
                                    <div style="color: #515a6e; font-size: 15px; letter-spacing: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px;">${body.title}</div>
                                  </div>
                                </div> 
                                <div style="justify-content: space-between; width: 85%; margin-left: 45px;">
                                  <p style="color: rgba(0, 0, 0, 0.45); font-size: 14px; line-height: 14px;">${body.updateTime}</p>
                                </div>
                          </li>
                      </ul>
                    </div>`
        });
      },

      notice: function(body){
        let imgStr = "";
        if(body.sessionChannel == '-25'){  //小程序
          imgStr = '<img title="小程序咨询" src="data:image/png;base64,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"/>';
        }else if(body.sessionChannel == '-24'){  //微信
          imgStr = '<img title="微信咨询" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAAAXNSR0IB2cksfwAAAAlwSFlzAAASdAAAEnQB3mYfeAAABWtJREFUeJylVglQk0cUjooioFWrVhFFq7TWGYd6tFK1h1qhBSoBBRTkPsSqeOEBSK2DFhTHWtsKEkg4QkJCbMopioBYUc4SQURgMghBGDooHu2AKPT1vdVEUBCKb2bnZ3ez+73je9/C4fRhjZ3lw1OqjzucuuqSEJi5SuH7+8LmbXLjv3anLlEGZ1vmCMr8wvKbJCZ9nR2SZddHuexK/bjOWqADllEjwC5uHLgkTgNXyXTYKHoHbGJ0cX0YbBBOgtDctVlVbZc+fCNAXvF2vjmPA9aC0eCZNBu8ZUbglTTnlUHrronT4etIDtjHTYB8ldBzSIBnCrbIVoRzwF0yE9wkMzCi0SxCH9ncXoA0dxZPY/vu0pmwPn4CfIWO5jWIvP4XYIby521fagAN8TJDOJRlgXNDFpF30rOI6UtzD+ks+B73yTkP6bsY7Tgsw1ugfFBqNCjAps4aPfT+X9u4sSylFEFBvRzIihpSwBrnBEKgHpJZsDZWB0oaM9j+lTopcGNGMWco1SF5dlcHBZpSc8KX6ugte49FaiXQgvq2G+xS1f2bOB/J1gmUvtYx2tD0sIbtK+/+CZZ8DpJqInD5I2HVaQ5cazm7YkDQY7n26VzBqOcpNAJHZOjuVBOIKw1kX0fR5F7pdUyYDPvSPwV+0R5wEE4GrkAbvrtgVn66cLPo2B/20aXNaUsGBN0qN77lmjhDQ5TNZ+fBhoSJYB7FAQf80vwFkYxgi3w+rI7gAJEuoujb4/kqidt5ZYTHb1VhW6U3DwUISnaFocN7cm7HmjZ3Vg3rB3R+jVuiYZ+t8fLYJHsfLLAUQRfM8hWt55dn1oa7h+TYZBG5bGJ0WKtZYZppEKtRTOqlN474vwJ6JNsma22sLovidYA+Z+cyUTiaty6jsb1iTuglexmRx/QMZWRSj9YyYs4Rm2nPHH8TkLmi7F6n0kADKq44fMAi6hmR+gOkWtrHj4edqYuVqo6yefvSlt2iiEmh/NKWMrFwFuuzOwiQeLA9eQHsSFnM/ibndiQvarn/tEGXgdY+KtZ3ERsgKSb2q0DkPbHzyp0El8iS7QmmWFMbzM6Jy06MxY0Pqhkoicl6ITqX8hE87X6M4wn4pX6C7H4bSAdOFrgna6IVVR48RnT3IunrI82OmL5DFy2uX2oQOtqiEHiiIJhHcyCy0JeBdnd3gQuqlJN4KqyL04O9yG61BZ5bhb2tx/bXo2QqWrMWaIAP53ILV4dzNOnsCWrN1wZReVCouOLgEUtNKWaDc6I+RusM/hlfsFaiTNEgJ0NybOForr2m5egMkY1X4husAe2AeyN+vLJR7oCHSdp6gpJKJd0I3f3rtc1Rtui1mskU8Rr+cLCLH8uIpnaY9kipuCgsBKYuG4mLr9w4theT77RXjHVD+pPCWPG1WB3paSMiiK8HB0UUbo18xvSB26svXlBr+aWaRPcCTa466bb8FIeRSlC6NzKyeCdvb/rSBru48V1CxYGfROUHQ6htXsf0fjsAz5B6xZTtD9QAtnQotZAArT4y49ryu5mfq9ebuhTDrrUIDSpbL0wpaUoxtca0uT9/AAYNiFE6iaZgMJOg6lHeBxrQxselOjmqaLd+peu5BeesKTfDllHXcLBRrsTu4BXvEL7u7n6tpePWDFeJYReJwyYiyUBKhkq1JloL/DM/U3Z0t2oNCZTs9t/FC33lC1RmKHOksZ4vsZ0G/TNA8rgudgwEnFup+Ke7acyQAV9EXKMbVborDB+MNmI4lz8KGY9tgj1Nw0k0FaVw0RNK6+GL39S9MWBPq36YPS65+oRVrGJ/UHiRD++XQq8z8RUBAXkNfLO6R4X6ksofgvCNbr9cL16mPvMfA0tuXlyDS20AAAAASUVORK5CYII="/>';
        }else if(body.sessionChannel == '-23'){  //网页
          imgStr = '<img title="小程序咨询" src="data:image/png;base64,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"/>';
        }

          this.$notify({
            title: '工单消息提醒',
            dangerouslyUseHTMLString: true,
            message: '<div style="width:280px"><ul style="list-style: none;display: block;"><li style="padding: 8px 0; border-top: 1px solid #e4e7ed; padding-left: 10px; padding-right: 10px;"><div style="display: flex;align-items: center; height: 30px;"><div style="margin-right: 16px; margin-top: 10px;">'+imgStr+'</div> <div style="width: 85%; overflow: hidden;"><div style="font-weight: bold; color: #515a6e; font-size: 15px; line-height: 15px; display: inline-block;">工单#'+body.msgMarket+'</div> <div style="float: right; color: #515a6e; font-size: 15px; letter-spacing: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 150px;">'+body.orderTheme+'</div></div></div> <div style="color: rgba(0, 0, 0, 0.45); font-size: 14px; line-height: 30px; width: 85%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-left: 45px; letter-spacing: 1px;"><b>'+body.content+'</b></div> <div style="justify-content: space-between; width: 85%; margin-left: 45px;"><p style="color: rgba(0, 0, 0, 0.45); font-size: 14px; line-height: 14px;">'+body.createTime+'</p></div></li></ul></div>'
          });
       
      },
    disconnect: function(){
      //关闭连接
      if (this.subscribeId) {
        this.mqClient.unsubscribe(this.subscribeId);
        this.mqClient.disconnect();
        this.subscribeId = "";
      }
    },
    init: function(){
      // 先查看本地有没有值
      this.onlineInfos = this.$store.getters.getOnlineInfos();
      //重新签入，未读消息设为0，后面调接口会重新获取未读消息
      this.$store.commit('removeGlobalNoticeMsgList','clearAll');
      // if(onlineInfos.length <= 0){
        let param = {
          journalType:"null",
          menuId:"null",
          type: '3',  //1待处理 2排队中,3全部
          pageNum: "0",
          pageSize: "0",
        }
        let that = this;
        this.$http.post("orderNotice/toIndex.json",param).then(function (res) {  //工单未读消息查询
          let result=res.data.flag;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          
          let contentList = res.data.obj.list;
          // 循环放到本地中
          contentList.forEach(item => {
            that.$store.commit('pushGlobalNoticeMsgList',JSON.parse(item.noticeMsg));
          });

          let agentInfo = JSON.parse(localStorage.getItem("agentInfo"));
          param={
            isPublishId:agentInfo.employeeId,
          };
          that.$http.post("notice/toIndex.json",param) .then(function (res) {
            result=res.data;
            let noticeTable=result.obj.list;
              noticeTable.forEach(item=>{
                if(item.isRead == 0){
                  that.$store.commit('pushNotice',item);
                }
              }); 
          })

        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/js/ChatService.js